/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Billing_Chip_OnInputs */



/**
* | output |
* | --- |
* | "Billing active" |
*
* @param {Partner_Admin_Billing_Chip_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_chip_on = /** @type {((inputs?: Partner_Admin_Billing_Chip_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Chip_OnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abrechnung aktiv")
	return /** @type {LocalizedString} */ ("Billing active")
});